export default __webpack_public_path__ + "215af9c85399a0cd193d17b0016fafc0.jpg";